import React from "react";
import Meta from "../components/settings/Meta";
import DashboardLayout from "../components/dashboard/DashboardLayout"; // Import DashboardLayout
import { requireAuth } from "./../util/auth";

function TrendAnalysisPage(props) {
  return (
    <>
      <Meta title="Analyse Your Metric Trends" />
      <DashboardLayout>
      </DashboardLayout>
    </>
  );
}

export default requireAuth(TrendAnalysisPage);
